import { api } from "@shared/lib/api";
import {
  BackednResponse,
  IGetGlobalCreators,
  IGetModifiedGlobalCreators
} from "@shared/lib/types";
import { IAutoCompleteInfluencer } from "@shared/lib/types/globalDiscovery";
import { queryToInsightsIqConverter } from "../utils/queryToInsightsIqConverter";

export class GlobalDiscoveryService {
  public static async getCreators({
    limit,
    offset,
    work_platform_id,
    searchParams,
  }: {
    searchParams: { [key: string]: any };
    limit: number;
    offset: number;
    work_platform_id: string;
  }) {
    const body = queryToInsightsIqConverter(
      searchParams,
      limit,
      offset,
      work_platform_id
    );

    const url = `social-media/search/insights-iq/by-pass?url=/v1/social/creators/profiles/quick-search`;
    if (
      searchParams?.searchType === "search-by-profile" &&
      !searchParams?.username
    ) {
      return new Promise<BackednResponse<IGetModifiedGlobalCreators>>(
        (resolve) => {
          setTimeout(() => {
            resolve({
              success: true,
              msg: "Mocked response",
              data: { data: [] },
              statusCode: 200,
            });
          }, 0);
        }
      );
    }

    const influencersRaw = (await api
      .post(url, {
        json: body,
      })
      .json()) as BackednResponse<IGetGlobalCreators>;

    const modifiedInfluencers = (await api
      .post(
        `social-media/search/insights-iq/transform-quick-search?work_platform_id=${work_platform_id}`,
        {
          json: {
            data: influencersRaw?.data?.data,
            metadata: influencersRaw?.data?.metadata,
          },
        }
      )
      .json()) as BackednResponse<IGetModifiedGlobalCreators>;
    return modifiedInfluencers;
  }

  public static async getFacets({
    facetName,
    text,
    work_platform_id,
  }: {
    facetName: string;
    text?: string;
    work_platform_id?: string;
  }) {
    return (await api
      .post("social-media/search/insights-iq/facets", {
        json: {
          facetName,
          text,
          work_platform_id,
        },
      })
      .json()) as BackednResponse<any>;
  }

  public static async autoCompleteInfluencers({
    text,
    work_platform_id,
  }: {
    text: string;
    work_platform_id: string;
  }) {
    const queryParams = new URLSearchParams({
      query_text: text,
      work_platform_id,
      type: "search",
      limit: "3",
    });

    return (await api
      .get(
        `social-media/search/insights-iq/by-pass?url=${encodeURIComponent(
          "/v1/social/creators/dictionary/userhandles?" + queryParams.toString()
        )}`
      )
      .json()) as BackednResponse<{ data: IAutoCompleteInfluencer[] }>;
  }
}
